import React, { useState } from "react";
import { useParams } from "react-router";
import { NavBarThree } from "../components/Header";
import { FootBar } from "../components/Footer";
import { RepositoryItems } from "../components/Component";
import { useQuery } from "@tanstack/react-query";
import { RepoContainer } from "../components/Container";
import { CreateFolderModal } from "../components/Modal";
import { RepositoryApi } from "../app/api/repository.api";


const repo = RepositoryApi();

export function SharedRepository()
{
    const {token} = useParams(); 

    const fetchFolders = async () => {
        const {data} = await repo.findSharedRepo(token)
        return data.data;
    };
                 
    const { data, error, isLoading, refetch } = useQuery({
        queryKey: ["data"],
        queryFn: fetchFolders,
    });

    const [ modalState , setModalState ] = useState(false);
    const closeModal = ( arg ) => {  setModalState( arg ) }    
    const setModal = () => setModalState(true);


    return(

        <div className="container-fluid">
            { modalState ? ( <CreateFolderModal method={ closeModal } repId={data?.id} refetch={refetch} /> ) : null }
            <div className="row">                                 
                {/* *************************************************************** */}
                <div className="col-lg-12 sticky-top bg-light border-bottom">  <NavBarThree target={'panel'} />  </div>
                <div className="col-md-12">  
                    <div className="row min-vh-100">  
                        {/* ----------------------------------------------------------------------- */}
                        <div className="col-lg-3 px-4 pt-4 pb-5 bg-light border-bottom ">
                            <div className="row">
                                <div className="col-md-12"> 
                                    <RepoContainer />  
                                </div>
                                <div className="col-md-12">
                                    <div className="border d-flex flex-column rounded-2 mt-4">
                                        <span className="p-3 border-bottom text-secondary"> Nouveau répertoire </span>
                                        <div  className="p-3 text-muted"> 
                                            <a href="/nouveau-repertoire" className="btn btn-green btn-sml"> 
                                              Ajouter <i className="bi bi-arrow-right ms-1"></i>
                                            </a> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* ------------------------------------------------------------------------- */}
                        <div className="col-lg-9 border-start border-bottom bg-light pb-4">
                            <div className="row gap-3 d-flex align-items-center justify-content-between border-bottom mb-3 py-4 px-3">
                                <div className="col-sm-6">
                                    <span className="p-3 alert alert-danger px-4 py-2 rounded-0"> Répertoire partagé </span>
                                </div>
                                <div className="col-sm-3">
                                   <button className="btn btn-sm btn-green" onClick={ setModal }> 
                                      Nouveau <i className="bi bi-plus-circle ms-1"></i>
                                   </button>
                                </div>   
                            </div>
                            <div className="row">
                                <div className="col-lg-12 p-4">
                                    <div className="row">
                                        {   
                                            (isLoading) ? ( 
                                                <div className="col-lg-12 d-flex justify-content-center p-4" >  
                                                   <div className="placeholder" style={{ height:'200px' }}></div>
                                                </div> ) : null 
                                        }                                                  
                                        {
                                            ( Array.isArray(data?.folders) && data?.folders.length > 0  ) ?    
                                            ( data?.folders.map( (item, index )=> (
                                                
                                                <div className="col-md-4 col-sm-6" key={index}> 
                                                    <RepositoryItems link={`/rep/${ data?.id }/${ item?.id }`} title={ item?.name } /> 
                                                </div>

                                            ))
                                            ) : (  ( Array.isArray(data) && data.length === 0  ) ?
                                                ( 
                                                    <div className="d-flex justify-content-center pt-5"> 
                                                        <div className="col-lg-5 col-md-8 border p-5 d-flex justify-content-center align-items-center lead text-secondary">  
                                                           Liste de répertoires vide 
                                                        </div>
                                                    </div> 
                                                ) : null 
                                            )
                                        }                                     
                                        {   
                                            (error) ? ( 
                                                <div className="row d-flex justify-content-center pt-5"> 
                                                    <div className="col-lg-5 col-md-8 border p-5 d-flex justify-content-center align-items-center lead text-secondary">  
                                                       Erreur serveur interne  
                                                    </div>
                                                </div> 
                                                ) : null  
                                        } 
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </div>     
                </div> 
                {/* *************************************************************** */}
                <div className="col-lg-12 bg-dark">  <FootBar />  </div>
            </div>
        </div>  
    )
}